import React, { useEffect } from 'react';
//componets
import FlNav from './landingComponents/Navbar';
import FlFooter from './landingComponents/Footer';

//Mansory - Bento grid
import Masonry from 'react-masonry-css';


//Iconos
import icn_01 from '../../assets/img/landingPage/financial/icn_financial_02.png';
import icn_02 from '../../assets/img/landingPage/financial/icn_financial_05.png';
import icn_03 from '../../assets/img/landingPage/connectors/connectors_01_data.svg';

import keyfeature01 from '../../assets/img/landingPage/integration/integration-02.png';
import keyfeature02 from '../../assets/img/landingPage/connectors/Connectors_02.png';
import keyfeature03 from '../../assets/img/landingPage/flow/flow-03.png';

import fondo from '../../assets/img/landingPage/fondo.png';
import ReactGA from 'react-ga4'

import Favicon from '../../assets/img/Favicon_AVAP_Framework.png'

//Importaciones de otros archivos, revisar y borrar
import gradientApi from '../../assets/img/landingPage/gradientApi.png'
import gradientServices from '../../assets/img/landingPage/gradientServices.png'

import product_gateway from '../../assets/img/landingPage/Gateway.png'
import dashboard from '../../assets/img/landingPage/automation/Automation_dashboard.png';


const Automation = () => {


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])

    useEffect(() => {
        // favicon 
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = Favicon; // Usa la ruta importada directamente
        document.head.appendChild(link);
    
        // clean favicon 
        return () => {
          document.head.removeChild(link);
        };
      }, []);

    useEffect(() => {

        document.body.classList.add('dark-bg');
        return () => {
            document.body.classList.remove('dark-bg');
        };

    }, []);

    const productDetailsA = {
        Key_Feature_01: {
            title: 'AI-native Document Intelligence',
            text: "Capture, classify, and act on documents using AVAP's Developer Portal. Extract data with natural language prompts, including structured fields and tables, and auto-summarize to generate instant, actionable insights.",
            altDescription: "Capture, classify, and act on documents using AVAP's Developer Portal. Extract data with natural language prompts, including structured fields and tables, and auto-summarize to generate instant, actionable insights.",
            image: keyfeature01,
        },
        Key_Feature_02: {
            title: "Legacy-to-AI Automation",
            text: "Connect legacy systems, CRMs, ERPs, and cloud services in seconds using AVAP Connectors, without coding or rewriting APIs. Query and trigger data from any system and orchestrate outcomes using AVAP Flow, our low-code automation builder.",
            altDescription: "Connect legacy systems, CRMs, ERPs, and cloud services in seconds using AVAP Connectors — without coding or rewriting APIs. Query and trigger data from any system and orchestrate outcomes using AVAP Flow, our low-code automation builder.",
            image: keyfeature02,
        },
        Key_Feature_03: {
            title: 'Orchestrate Humans and AI Agents',
            text: 
            "Design workflows where human input meets AI action. With AVAP Flow, you can, assign steps to users, apps, or bots, use dynamic forms to collect input, track execution across systems and teams, trigger actions based on context and outcomes",
            features: [
                "Assign steps to users, apps, or bots.",
                "Use dynamic forms to collect input.",
                "Track execution across systems and teams.",
                "Trigger actions based on context and outcomes."
              ],
            altDescription: 'Design workflows where human input meets AI action.',
            image: keyfeature03,
        },
    }
    
    //Key Benefits Bento
    const items = [
        {
          icon: icn_01,
          title: 'Speed without technical debt',
          paragraphs: [
            'Build reusable, scalable automation that integrates and adapts without starting from scratch.',
        ]
        },
        {
          icon: icn_02,
          title: 'Boost productivity across teams',
          paragraphs: [
            'Free your people from repetitive tasks and help AI agents act with accuracy.',
          ]
        },

        {
          icon: icn_03,
          title: 'Deliver better outcomes, faster',
          paragraphs: [
            'Surface the right data at the right time, every time.',
          ]
        },
    ];

    const breakpointColumnsObj = {
        default: 3, //Cambio de columnas verticales
        1100: 2,
        700: 1
      
    };


    return (
        <>
            <FlNav></FlNav>
            <div id="pricing"
            className="fl-cloud-product bg-black text-white"
            style={{ backgroundImage: `url(${fondo})` }}
            >
                {/* Hero Section */}
                <section id="heroProduct" className="text-center py-5">
                    <h1 className="fl-title-big m-0">Automation</h1>
                    <p className="fl-title m-0 gradient-text">Autonomous workflows, powered by <br /> virtualization and Gen-AI</p>
                                <p className="fl-text fl-txt-container-s" >
                                Empower every team to automate work faster and smarter with AVAP Framework’s virtual-first, low-code platform, 
                                built to orchestrate tasks, data, and systems for both humans and AI agents.
                                </p> 
                </section>


                {/* Subtítulo descripción */}
                <section 
                className="text-center pb-5">
                    <img
                        src={dashboard}
                        className="img-fluid mt-2 pb-8"
                        style={{ width: '70%', maxWidth: '800px', height: 'auto' }}
                    />

                     <br />
                    &nbsp;
                    <br />&nbsp;
                    <br />
                    &nbsp;
                    <br />&nbsp;

                    <h2 style={{ marginTop: '40px' }} className="fl-title m-0 gradient-text fl-title m-4">Accelerate automation across <br/> your organization</h2>
                    <p className="fl-text text-center fl-txt-container-s">
                    AVAP Automation gives business and IT teams the power to rapidly create, deploy, and govern intelligent workflows, using virtualized integrations, Gen-AI capabilities, and prebuilt logic blocks. Orchestrate processes that span modern apps, legacy systems, and everything in between.

                    </p>
                </section>

                {/* Sección Key Features */}
                <div className="fl-wrapper">
                    <img src={gradientServices} className="gradient gradientServices" alt="" />
                    <img src={gradientApi} alt="" className="gradient gradientlife" />
                    <div className="fl-container">
                        <section id="products">
                            {/*   <h3 className="fl-title text-center">Our Products & Services</h3> */}
                            <br />
                            &nbsp;
                            <br />&nbsp;
                            <p className="fl-title-center m-0">Key Features</p>
                            <div className="fl-productsWrapper">
                                {Object.keys(productDetailsA).map((productKey, index) => (
                                    <div key={productKey} className="fl-product-item">
                                        <div className={`row align-items-center ${index % 2 === 0 ? '' : 'flex-row-reverse'}`}>
                                            <div className="col-md-6">
                                                <div className="product-content">
                                                    <h3 className="fl-subtitle">
                                                        {productDetailsA[productKey].title}
                                                    </h3>
                                                    <p className="fl-text">
                                                        {productDetailsA[productKey].text}
                                                    </p>
                                                    {/* Lista de bullets para features */}
                                                    {productDetailsA[productKey].features && (
                                                    <ul className="fl-bullets fl-text fl-txt-container-s">
                                                        {productDetailsA[productKey].features.map((feature, i) => (
                                                        <li key={i}>{feature}</li>
                                                         ))}
                                                    </ul>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <img
                                                    src={productDetailsA[productKey].image}
                                                    alt={productDetailsA[productKey].altDescription}
                                                    className="img-fluid product-preview"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </section>
                    </div>
                </div>

                {/*MASONRY 2 COLUMNAS, ICONO CENTRADO, FONDO GRIS, TITULO Y PÁRRAFO */}
                <div className="container">
                <div className="fl-title text-center mb-5">
                    Key Benefits
                    </div>
                    <Masonry
                    breakpointCols={breakpointColumnsObj}
                    className="masonry-grid"
                    columnClassName="masonry-column"
                    >
                    {items.map((item, idx) => (
                        <div key={idx} className="fl-card-s text-center grayGradient">
                        <img src={item.icon} alt="Icon representing 0X" className="solutionsIcon" />
                        <p className="fl-subtitle-xs">{item.title}</p>
                        {item.paragraphs.map((p, i) => (
                            <p key={i} className="fl-text">{p}</p>
                        ))}
                        </div>
                    ))}
                    </Masonry>
                </div>

                {/* Sección Key Benefits */}   
                {/*<section className="container fl-z-index-2 position-relative mb-8">
                    <div className="row">
                        <div className="col  mb-5">
                            <div className="fl-title text-center mb-3">
                                Key Benefits
                            </div>
                        </div>
                    </div>
                    <div className="row ">
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                
                                <p className="fl-subtitle-xs">
                                    Speed without technical debt
                                </p>
                                <p className="fl-text">
                                Build reusable, scalable automation that integrates and adapts without starting from scratch.

                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                               
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                     Boost productivity across teams
                                </p>
                                <p className="fl-text">
                                    Free your people from repetitive tasks and help AI agents act with accuracy.
                                    <br />&nbsp;
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                    Deliver better outcomes, faster
                                </p>
                                <p className="fl-text">
                                    Surface the right data at the right time — every time.

                                </p>
                            </div>
                        </div>
                    </div>
                </section>*/}

                {/* Sección built for secure */} 
                <section className="container">
                    <div className="row">
                        <div className="col">
                            <div className="blobContainer mb-8 mt-4">

                                <div className="blob"></div>
    

                                <div className="text-center">
                                    <h3 className='fl-title'>Built for secure, hybrid-ready automation</h3>
                                    <p>AVAP Automation runs where your business does, cloud, on-premise, or hybrid. With built-in security, governance, and monitoring, you stay in control no matter how fast you move.
                                    </p>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
            <FlFooter></FlFooter>
        </>
    );
};

export default Automation;
